import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Markdown from "src/components/Markdown";
import { useTranslation } from "react-i18next";

const spacingClassPattern = /\b(p|px|py|pt|pb|pl|pr)-/;

const TitleSection = ({
  title,
  text,
  as: Tag = "h1",
  dark = false,
  className,
  borderColor,
  textFontSize,
  backgroundColor,
}) => {
  const { t } = useTranslation();

  return (
    <Section
      dark={dark}
      className={`title-section ${className || ""}`}
      backgroundColor={backgroundColor}
      textFontSize={textFontSize}
      $hasSpacingClass={spacingClassPattern.test(className || "")}
    >
      <Tag>{t(title)}</Tag>
      <Rule $borderColor={borderColor} />
      <Markdown>{text}</Markdown>
    </Section>
  );
};

TitleSection.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  as: PropTypes.string,
  dark: PropTypes.bool,
  className: PropTypes.string,
  borderColor: PropTypes.string,
  textFontSize: PropTypes.string,
  backgroundColor: PropTypes.string,
};

const Section = styled.div`
  ${(props) => !props.$hasSpacingClass && `padding: 40px 0;`}
  height: fit-content;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  letter-spacing: 1px;
  text-align: center;
  color: ${(props) => (props.dark ? "var(--black)" : "var(--white)")};
  background-color: ${(props) => props.backgroundColor || "transparent"};

  & > h1, & > h2 {
    margin: 0;
    font-weight: 900;
    margin-bottom: 10px;
    font-size: 45px;
    line-height: 1.2;
  }
  & > h3 {
    margin: 0;
    font-weight: 900;
    margin-bottom: 10px;
    font-size: 35px;
    line-height: 1.2;
  }
  & > p {
    width: 100%;
    max-width: 800px;
    text-align: center;
    font-size: ${(props) => props.textFontSize || "1.2rem"};
    padding: 0;
  }

  @media screen and (max-width: 991px) {
    ${(props) => !props.$hasSpacingClass && `padding: 20px 0;`}
    & > h1, & > h2 {
      text-align: center;
      font-size: 32px;
      padding: 0 20px;
    }
    & > h3 {
      text-align: center;
      font-size: 26px;
      padding: 0 20px;
    }
    & > p {
      padding: 0 20px;
    }
  }
`;

const Rule = styled.span`
  width: 100%;
  max-width: 275px;
  border-bottom: 2px solid ${(props) => props.$borderColor || "var(--red)"};
  margin-bottom: 20px;
`;

export default TitleSection;
